module.exports = __webpack_public_path__ + "static/media/back_of_left_thumb.aebaee91.svg";